<template lang="html">
  <div class="list">
    <div class="listCon" v-for="(a, index) in listCon" :key="index">
      <div class="conTop">
        <img :src="a.cover" alt="" class="groupBookingBanner">
        <div class="groupBookingCon">
          <p class="conTitle">{{a.title}}</p>
          <div class="thisPrice">
            <p class="conNum">{{a.number}}人团</p>
            <p class="orignPrice"><s>￥{{a.orign_price}}</s></p>
            <p class="price">拼团价 ￥{{a.price}}</p>
          </div>
          <div class="teacherText">
            <div class="allTeacher">
              <div v-for="(b, index) in a.teacher" :key="index">
                <img :src="b.avatar" alt="" class="teacherImg">
              </div>
            </div>
            <p class="allTeacherName">
              <span class="teacherName" v-for="(c, index) in a.teacher" :key="index">{{c.username}}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="conBottom">
        <div>
          <p class="groupBookingTime">活动有效期:{{a.start_time}}-{{a.end_time}}</p>
          <p class="groupBookingNum"><span>{{a.view_num}}</span>人已领取课程</p>
        </div>

        <div class="groupBookingBtn" @click="getCourse(a.id)">
          发起拼团
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import WxShare from '@/utils/wxshare'
  import {
    apppagebase
  } from '@/utils/http.js'

  export default {
    data() {
      return {
        ynk: false,
        listCon: {},
      }
    },
    created() {
      this.init();
    },
    mounted() {
      this.showStat();
    },
    methods: {
      showStat() {
        this.$http({
          url: '/api/showStat',
          method: 'post',
          params: {
            url: window.location.href,
          }
        })
      },
      init() {
        this.getWx = new WxShare();
        this.getBuyTogetherList();
      },
      getBuyTogetherList() {
        this.$http('/course/buyTogetherList', {}).then(res => {
          if (res.code >= 0) {
            document.title = '拼团课';
            this.listCon = res.data;
            this.getWx.share({
              title: '邀好友，一起免费领好课',
              desc: '原华为专家组成的豪华授课团，超多好课等你领',
              link: window.location.href,
              imgUrl: apppagebase + '/static/img/20211210103741.jpeg',
            });
          }
        })
      },
      getCourse(tid) {
        this.$router.push({
          path: '/course',
          query: {
            tid: tid,
          }
        })
      }
    },
  }
</script>

<style lang="css" scoped>
  .list {
    background-color: #F7F8F8;
  }

  .listCon {
    padding: 1.5rem;
    box-sizing: border-box;
    margin-bottom: .6rem;
    background-color: #FFFFFF;
  }

  .groupBookingBanner {
    width: 13.7rem;
    height: 8.4rem;
    object-fit: cover;
    border-radius: .8rem;
    flex-shrink: 0;
  }

  .groupBookingCon {
    box-sizing: border-box;
    padding-left: 1rem;
  }

  .conTop {
    box-sizing: border-box;
    display: flex;
    padding-bottom: 1.4rem;
    border-bottom: .05rem solid rgba(0, 0, 0, 0.1);
  }

  .conTitle {
    height: 3.9rem;
    font-size: 1.4rem;
    font-weight: bolder;
    color: #1D2023;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .thisPrice {
    display: flex;
    align-items: center;
    padding: .3rem 0;
  }

  .conNum {
    font-size: 1.2rem;
    color: #808598;
    padding-right: 1.3rem;
    border-right: .1rem solid #808598;
    margin-right: 1rem;
  }

  .orignPrice {
    font-size: 1.2rem;
    color: #999999;
  }

  .price {
    font-size: 1.4rem;
    font-weight: bolder;
    margin-left: 1rem;
    color: #E50101;
  }

  .conTeacher {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .teacherText {
    height: 2.4rem;
    display: flex;
    align-items: center;
  }

  .allTeacher {
    display: flex;
    padding-left: .5rem;
  }

  .teacherImg {
    margin-left: -.5rem;
  }

  .teacherImg {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    object-fit: cover;
  }

  .allTeacherName {
    height: 2.4rem;
    line-height: 2.4rem;
    margin-top: -.6rem;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    word-break: break-word;
  }

  .teacherName {
    font-size: 1.3rem;
    color: #808598;
    margin-left: .4rem;
  }

  .groupBookingPrice {
    font-size: 1.2rem;
    color: #E6001F;
  }

  .conBottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 1.4rem;
  }

  .groupBookingTime {
    font-size: 1.2rem;
    color: #808598;
  }

  .groupBookingNum {
    margin-top: .5rem;
    display: inline-block;
    background-color: #FEF9F0;
    font-size: 1rem;
    padding: .2rem .8rem;
    border-radius: 2rem;
  }

  .groupBookingNum span {
    font-size: 1.2rem;
    color: #E57701;
  }

  .groupBookingBtn {
    position: relative;
    border-radius: 1.5rem;
    text-align: center;
    width: 8.8rem;
    height: 3rem;
    line-height: 3rem;
    font-size: 1.4rem;
    color: #FFFFFF;
    background-color: #FF0000;
  }
</style>
